import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface JettonMeta {
  master: string;
  name: string | null;
  symbol: string | null;
  decimals: number;
  imageUrl: string | null;
}

export function useJettonMetadata(master: string | undefined) {
  return useQuery<JettonMeta>({
    queryKey: ['jettonMeta', master],
    queryFn: () => api.getJettonMetadata(master!),
    enabled: !!master,
    staleTime: 24 * 60 * 60 * 1000, // 24h — metadata rarely changes
    gcTime: 24 * 60 * 60 * 1000,
  });
}
